import React from "react";
export const CardDescription = ({ mainTitle, mainDescription }) => (React.createElement("div", { className: "CardDescription" },
    React.createElement("h2", null, mainTitle),
    React.createElement("p", { dangerouslySetInnerHTML: { __html: mainDescription } })));
